module.exports = __webpack_public_path__ + "static/sbvc-a0b4a065941a25dec423f402dd03cbd2.png";